var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',[_c('v-list-item-content',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('b',_vm._g(_vm._b({},'b',attrs,false),on),[_vm._v(_vm._s(_vm.column.short_title))])]}}])},[_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.column.title))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }